import { USE_LEMONSOFT_B2C } from 'config/env'

export default USE_LEMONSOFT_B2C || localStorage.getItem('useLemon') === 'true'
